module.exports = __webpack_public_path__ + "img/img-15.83e7f262.svg";